import {Controller} from 'stimulus';
import Swiper, {EffectFade, Navigation, Pagination} from 'swiper';

Swiper.use([EffectFade, Navigation, Pagination]);

export default class extends Controller {
  connect() {
    this.initStorySlider();
  }

  /**
   * Initialize the stories slider
   * @returns {void}
   */
  initStorySlider() {
    // initialize the slider
    const storiesSlider = new Swiper(this.element.querySelector('.js-storiesSlider'), {
      slidesPerView: 1,
      speed: 400,
      threshold: 35,
      resistance: true,
      resistanceRatio: 0,
      slidesPerGroup: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    // Initialize counter
    const counterElement = this.element.querySelector('.stories__arrows--counter');
    const updateCounter = () => {
      const currentSlideString = (storiesSlider.realIndex + 1).toString().padStart(2, '0');
      const totalSlidesString = (storiesSlider.slides.length).toString().padStart(2, '0');
      counterElement.textContent = `${currentSlideString}/${totalSlidesString}`;
    };

    // Set initial counter value
    updateCounter();

    // Update counter when slide changes
    storiesSlider.on('slideChange', updateCounter);
  }
}
